const assetsSettingsLinks: any[] = [];
export default assetsSettingsLinks;
